import type { BrowserOptions, Event, Breadcrumb } from '@sentry/react';
import { BUILD_SENTRY_DSN } from '@lmt/shared-types';
export function getSentryOptions(
  version: string,
  dsn: string | undefined = undefined,
): BrowserOptions {
  if (process.env.NODE_ENV === 'development') {
    return {
      dsn: '',
    };
  }
  return {
    dsn: dsn ?? BUILD_SENTRY_DSN,
    release: version,
    beforeSend(event: Event) {
      if (event.breadcrumbs && isFilteredByBreadcrumbs(event.breadcrumbs)) {
        return null;
      }
      if (event.message?.includes("Patient doesn't exist")) return null;

      return event;
    },
  };
}

/*
Returns `true` if current event should be filtered (NOT sent to Sentry)
 */
function isFilteredByBreadcrumbs(breadcrumbs: Breadcrumb[]): boolean {
  const last5Breadcrumbs = breadcrumbs.slice(
    Math.max(breadcrumbs.length - 5, 1),
  );
  if (last5Breadcrumbs.find(breadcrumbFilterRule)) {
    return true;
  }
  return false;
}

/*
Returns `true` if current event should be filtered (NOT sent to Sentry)
if it contains the passed breadcrumb
 */
function breadcrumbFilterRule(breadcrumb: Breadcrumb): boolean {
  // some errors are caused by 401 unauthenticated.
  // it's ok to have them since Unicorn is secured by default Azure authentication
  return breadcrumb?.data?.status_code == 401;
}
